export default "__VITE_ASSET__TJS1pLpa__"